var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"active":_vm.showPrivacyAgreements}},[_c('Privacy')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }